import { array, number, object, string } from 'yup';
import { isNumber } from 'lodash/fp';
import { translateAndCastToString } from '../../../../utils';
import { UnitType } from '../../../../generated/graphql';
import { WarehouseCardFormValues } from './types';


export const newWarehouseCardValidationScheme = object().shape<WarehouseCardFormValues>(
    {
        name: string()
            .min(2, translateAndCastToString('Name should be at least 2 characters'))
            .max(50, translateAndCastToString('Name should be maximum 50 characters'))
            .required(translateAndCastToString('Name is required')),
        warehouseIds: array<string>().min(1, translateAndCastToString('At least one warehouse should be picked')).required(),
        sku:  string().nullable()
            .min(1, translateAndCastToString('SKU should be at least 1 character'))
            .max(50, translateAndCastToString('SKU should be maximum 50 characters')),
        storageUnitId: string<UnitType>().required(),
        taxId: string().required(),
        convertedQuanitity: number().nullable().when('convertedUnit', {
            is: (value: UnitType) => !!value,
            then: number().required(translateAndCastToString('Specify alternative unit or delete the conversion amount')),
            otherwise: number().nullable(),
        }).test(
            'convertedQuanitity',
            translateAndCastToString('Converted amount is limited with 3 decimals'),
            num => isNumber(num) ? /^\d+(\.\d{1,3})?$/.test(num.toString()) : true,
        ).positive().moreThan(0).max(1000),
        convertedUnit: string<UnitType>().nullable().when('convertedQuanitity', {
            is: (value: number) => isNumber(value),
            then: string().required(translateAndCastToString('Specify alternative unit or delete the conversion amount')),
            otherwise: string().nullable(),
        }),
        categoryId: string().nullable(),
    },
    // https://github.com/jquense/yup/issues/720#issuecomment-564591045
    [['convertedQuanitity', 'convertedUnit']]
);
